export const ACCOUNT_LOGIN="/account/login";
export const ACCOUNT_REGISTER="/account/register";
export const ACCOUNT_LOGOUT="/account/logout";
export const ACCOUNT_LOGOFF="/account/logoff";
export const ACCOUNT_PASSWORD="/account/password";